import { useId } from 'react';
import { CheckboxField, Spinner } from '../../components/ui';
import { t } from '../../lib/i18n';
import { useGroups, useSites } from './api';

interface PickerProps {
  /** null = every one. */
  value: string[] | null;
  onChange: (next: string[] | null) => void;
  disabled?: boolean;
  error?: string | undefined;
}

function Picker({ legend, allLabel, items, value, onChange, disabled, error }: PickerProps & { legend: string; allLabel: string; items: { id: string; name: string }[] | undefined }) {
  const id = useId();
  if (!items) return <Spinner />;
  const toggle = (itemId: string, on: boolean) => {
    const current = value ?? [];
    onChange(on ? [...current, itemId] : current.filter((x) => x !== itemId));
  };
  return (
    <fieldset className="space-y-2" aria-describedby={error ? `${id}-err` : undefined}>
      <legend className="mb-1 text-sm font-medium text-slate-800">{legend}</legend>
      <CheckboxField label={allLabel} checked={value === null} disabled={disabled} onChange={(e) => onChange(e.target.checked ? null : [])} />
      {value !== null ? (
        <div className="ml-8 grid gap-2 sm:grid-cols-2">
          {items.map((it) => (
            <CheckboxField key={it.id} label={it.name} checked={value.includes(it.id)} disabled={disabled} onChange={(e) => toggle(it.id, e.target.checked)} />
          ))}
        </div>
      ) : null}
      {error ? (
        <p id={`${id}-err`} className="text-sm text-red-700">
          {error}
        </p>
      ) : null}
    </fieldset>
  );
}

export function SitePicker(props: PickerProps) {
  const sites = useSites();
  return <Picker {...props} legend={t('ntf.picker.sites')} allLabel={t('ntf.picker.allSites')} items={sites.data} />;
}

export function GroupPicker(props: PickerProps) {
  const groups = useGroups();
  return <Picker {...props} legend={t('ntf.picker.groups')} allLabel={t('ntf.picker.allGroups')} items={groups.data} />;
}
